import { render, staticRenderFns } from "./EmbedIndex.vue?vue&type=template&id=63a15b7c&scoped=true"
import script from "./EmbedIndex.vue?vue&type=script&lang=js"
export * from "./EmbedIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a15b7c",
  null
  
)

export default component.exports